import "@tento-ui/components/prompt";

import { LonaWebComponent, html } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css, Style } from "@tento-ui/component-styles";
import { Button } from "@tento-ui/components/button/button";
import { Toaster } from "@tento-ui/components/toast/toaster";
import { GESTURE_MANAGER } from "@tento-ui/gesture-manager";
import { Typography } from "@tento-ui/ui/typography";

export type BrandVariantPickerVariant = {
  id: string;
  label: string;
  detail: Option<string>;
};

export type BrandVariantPickerProps = {
  activeVariant: string;
  variants: BrandVariantPickerVariant[];
  onSelect: (variant: string) => void;
};

@component({ name: "std-brand-variant-picker" })
export class BrandVariantPicker extends LonaWebComponent {
  private static persistentHandle: Option<Toaster.Persistent.Handle>;

  private $list: HTMLElement = this.$("list");

  bind(props: BrandVariantPickerProps): this {
    this.$list.textContent = "";

    for (const variant of props.variants) {
      const $btn = Button.makeWith(variant.label, {
        type: variant.id === props.activeVariant ? "primary" : "secondary",
      });
      $btn.title = variant.detail ?? variant.label;

      GESTURE_MANAGER.addPointerEvent($btn, {
        onClick: () => props.onSelect(variant.id),
      });

      this.$list.appendChild($btn);
    }

    return this;
  }

  static makeWith(props: BrandVariantPickerProps): BrandVariantPicker {
    return BrandVariantPicker.make().bind(props);
  }

  static showPersistent(props: BrandVariantPickerProps) {
    if (BrandVariantPicker.persistentHandle) {
      BrandVariantPicker.persistentHandle.dismiss();
      BrandVariantPicker.persistentHandle = undefined;
      return;
    }

    const $picker = BrandVariantPicker.makeWith(props);
    BrandVariantPicker.persistentHandle = Toaster.showPersistent(
      "brand-variant-picker",
      $picker,
    );
  }

  static $styles: Style.Compat[] = [
    Button.$style,
    Typography.$style,
    css`
      #title {
        --margin-top: 0px;
        --margin-bottom: 0px;
        color: var(--text-sec);
      }

      #text {
        padding: 20px;
      }

      #list {
        padding: 0 20px 20px;
        gap: 8px;
      }
    `,
  ];

  static $html = html`
    <std-prompt-layout id="root">
      <std-col slot="text">
        <std-col id="text">
          <h1 id="title" class="h3">Variant</h1>
        </std-col>
        <std-col id="list"></std-col>
      </std-col>
    </std-prompt-layout>
  `;
}
